__turbopack_context__.v({
  "container": "XVlzpq_container",
});
